/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { batch, useDispatch, useSelector } from 'react-redux';
import ResizeObserver from 'react-resize-observer';

import LayoutWithSidebarNav from '../../../../../shared/components/Layout/LayoutWithSidebarNav';
import Spinner from '../../../../../shared/_TBComponents/Spinner';
import { generalSettingsSideBarNavArrayOfObjects } from '../../../../../shared/constants';
import { getOrganizationSettings } from '../../../../login/ducks/loginActions';
import { fetchSubscriptionStatus } from '../../../../sports-science/ducks/sportsScienceActions';
import AvatarAndTitleComponent from './AvatarAndTitleComponent';
import BetaSettings from './BetaSettings';
import CustomLoginPage from './CustomLoginPage';
import OrganizationInformation from './OrganizationInformation';
import OrganizationPreferences from './OrganizationPreferences';
import OrganizationSettingsSavingIndicator from './OrganizationSettingsSavingIndicator';
import PageManagementSettings from './PageManagementSettings';
import WeightRoomViewGlobalSettings from './WeightRoomViewGlobalSettings';

const HELMET_TEXT = 'Account Settings';

const NAV_LINK_ARRAY_OF_OBJECTS = generalSettingsSideBarNavArrayOfObjects;

const Container = styled('div')`
  position: relative;
  input:focus {
    outline: 5px dotted green;
  }
  .error-message {
    color: #ff6600;
    font-size: 14px;
    margin-top: 10px;
  }
  @media (max-width: 800px) {
    padding-top: 50px;
  }
`;

const SpinnerWrapper = styled('div')`
  display: flex;
  height: 100vh;
`;

const OrganizationSettingsPage = () => {
  const dispatch = useDispatch();
  const [containerWidth, setContainerWidth] = useState(null);

  const accountCode = useSelector((state) => state.auth.data.currentUser?.accountCode);
  const isOrganizationSettingsLoading = useSelector(
    (state) => state.auth.ui.isOrganizationSettingsLoading,
  );

  useEffect(() => {
    if (accountCode) {
      batch(() => {
        dispatch(getOrganizationSettings(accountCode));
        dispatch(fetchSubscriptionStatus(accountCode, '1'));
      });
    }
  }, [accountCode, dispatch]);

  const handleResize = (rect) => {
    setContainerWidth(rect.width);
  };

  return (
    <LayoutWithSidebarNav
      helmetText={HELMET_TEXT}
      navLinkArrayOfObjects={NAV_LINK_ARRAY_OF_OBJECTS}
      sideBarTitle='Settings'
      sideBarTitleIcon='settings'
    >
      <OrganizationSettingsSavingIndicator />
      {isOrganizationSettingsLoading ? (
        <SpinnerWrapper>
          <Spinner large />
        </SpinnerWrapper>
      ) : (
        <Container>
          <ResizeObserver onResize={handleResize} />
          <AvatarAndTitleComponent containerWidth={containerWidth} />
          <OrganizationInformation />
          <OrganizationPreferences />
          <WeightRoomViewGlobalSettings containerWidth={containerWidth} />
          <CustomLoginPage containerWidth={containerWidth} />
          <BetaSettings containerWidth={containerWidth} />
          <PageManagementSettings containerWidth={containerWidth} />
        </Container>
      )}
    </LayoutWithSidebarNav>
  );
};
export default OrganizationSettingsPage;
